<template>
  <div class="work">
    <main class="content">
      <questions :data="{ ...examData, list: quesList, done }" @checked="questChecked"></questions>
      <!-- <h3 class="title" style="padding-bottom: 16px;border-bottom: 1px solid #c8d1ee;">
        第一章 总论/【考点17】城市维护建设税与教育费附加/作业
      </h3> -->
      <!-- <div>
        <div class="content_type">
          <span class="title">单选题</span>
          <span>（共10题）</span>
        </div>
        <div class="topic">
          <h4 class="topic_title">
            1、王老师经常反问自己：怎样科学设计教学目标？怎样有效改善科学效果？怎样提高学生成绩？
            这表明王老师所的专业发展阶段是（）
          </h4>
          <div class="topic_content">
            <div class="topic_item">
              <span class="circle">A</span>
              <p>任教前关注阶段</p>
            </div>
            <div class="topic_item">
              <span class="circle">A</span>
              <p>任教前关注阶段</p>
            </div>
            <div class="topic_item">
              <span class="circle">A</span>
              <p>任教前关注阶段</p>
            </div>
            <div class="topic_item">
              <span class="circle">A</span>
              <p>任教前关注阶段</p>
            </div>
          </div>
        </div>
      </div> -->
      <!-- <div>
        <div class="content_type">
          <span class="title">单选题</span>
          <span>（共10题）</span>
        </div>
        <div class="topic">
          <h4 class="topic_title">
            1、王老师经常反问自己：怎样科学设计教学目标？怎样有效改善科学效果？怎样提高学生成绩？
            这表明王老师所的专业发展阶段是（）
          </h4>
          <div class="topic_content">
            <div class="topic_item">
              <span class="circle">A</span>
              <p>任教前关注阶段</p>
            </div>
            <div class="topic_item">
              <span class="circle">A</span>
              <p>任教前关注阶段</p>
            </div>
            <div class="topic_item">
              <span class="circle">A</span>
              <p>任教前关注阶段</p>
            </div>
            <div class="topic_item">
              <span class="circle">A</span>
              <p>任教前关注阶段</p>
            </div>
          </div>
        </div>
      </div> -->
    </main>
    <div ref="survey" class="survey">
      <summary-card v-if="done" :data="rankData"></summary-card>
      <timer v-else @submit="submit"></timer>
      <answer-sheet :done="done" :list="quesList" @onAnchor="onAnchor"></answer-sheet>
    </div>
  </div>
</template>
<script>
import { feachExam, examSubmit, getExamRank } from '@/api/myClass'
import { feachObsO } from '@/api/system'
import summaryCard from './components/summary.vue'
import answerSheet from './components/answerSheet'
import questions from './components/questions'
import timer from './components/timer'
export default {
  name: '',
  data() {
    return {
      examData: {
        list: [],
        chapterName: '',
        name: '',
        done: false,
      },
      quesList: [],
      done: false,
      rankData: {
        list: [],
        useTime: 0,
      },
    }
  },
  components: {
    summaryCard,
    answerSheet,
    questions,
    timer,
  },
  created() {
    // const obj = {
    //   classesId: 'c6eb1e18c3ea2ff99e438222b187d7ac',
    //   done: false,
    //   examId: '151225b72392ebcea3ad6d9cf40f5fd9',
    //   examName: '【好题强化】  第一章',
    //   id: '81e2706b39e57a8c88784e2914651a43', // 试卷id
    //   knowId: '458f188689fa49c5c6cd287f8171b26a',
    //   planclassesId: 'ec937013e3d141b8a8233d9cd9c3438c',
    //   scheduleId: '30c3f155d4a408819259046b1f3331cd',
    //   seq: null
    // }
    // console.log('ewrewret', this.$route.params)
    // if (Object.hasOwn(this.$route.params, 'id')) {}
    // console.log('ewrewret', this.$route.params)
    if (this.$route.query.id) {
      this.params = this.$route.query
      this.feachExamAsync(this.params)
      return
    }
    if (this.$route.params.id) {
      this.$ls.set('params', this.$route.params)
      this.params = this.$route.params
    } else {
      this.params = this.$ls.get('params')
    }
    // this.$route.params
    // console.log('params', this.params)
    // this.params = this.$route.params.id ? this.$route.params : obj
    // if (!this.params) {
    //   // this.$message.error('参数异常')
    //   throw new Error('params cannot be empty')
    //   // return
    // }
    this.feachExamAsync(this.params)
  },
  mounted() {
    window.addEventListener('scroll', this.scrollHandel)
  },
  beforeDestroy() {
    // console.log('beforeDestroy')
    this.$ls.remove('params')
    window.removeEventListener('scroll', this.scrollHandel)
  },
  methods: {
    scrollHandel() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 66) {
        document.querySelector('.survey').style.top = 16 + 'px'
      } else {
        document.querySelector('.survey').style.top = 98 + 'px'
      }
    },
    async submit(useTime) {
      const { id, knowId } = this.examData
      const { planclassesId, classesId, scheduleId } = this.params
      // console.log('试卷id', id)
      // console.log('考点id', knowId)
      // console.log('课次id', scheduleId)
      // console.log('课程id', classesId)
      // console.log('班级id', planclassesId)
      // console.log('考试时长', time)
      // console.log('quesList', this.quesList)
      const answers = []
      this.quesList.forEach((ques) => {
        const arr = ques.result.filter((item) => item.userAnswer)
        answers.push(...arr)
        // console.log('ques', ques.result)
        // console.log('arr', arr)
      })
      // console.log('学员答题记录', answers)
      const res = await examSubmit({
        answers,
        examId: id,
        knowId,
        planclassesId,
        classesId,
        scheduleId,
        useTime,
      })
      console.log(res)
      this.feachExamAsync(this.params)
      this.getExamRankAsync(this.params)
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
    questChecked(i1, i2, letter) {
      console.log('i1---', i1)
      console.log('i2---', i2)
      console.log('letter---', letter)
      const myOption = this.quesList[i1].list[i2]['myOption']
      console.log('myOption', myOption)
      const result = this.quesList[i1].result[i2]
      console.log('result', result)
      // if (i1 === 1) {
      //   if (myOption.includes(letter)) {
      //     const arr = myOption.filter((item) => item !== letter)
      //     this.quesList[i1].list[i2]['myOption'] = arr
      //   } else {
      //     this.quesList[i1].list[i2]['myOption'].push(letter)
      //   }
      // } else {
      //   this.quesList[i1].list[i2]['myOption'] = [letter]
      // }
      this.quesList[i1].list[i2]['myOption'] = letter
      console.log('this.quesList[i1].list[i2]', this.quesList[i1].list[i2]['myOption'])
      this.quesList[i1].result[i2] = this.formatAnswers(result, { option: this.quesList[i1].list[i2]['myOption'] })
      console.log('this.quesList', this.quesList)
    },
    // 获取试卷排行
    async getExamRankAsync({ classesId, examId, planclassesId }) {
      try {
        const res = await getExamRank({ classesId, examId, planclassesId })
        // console.log('res', res)
        // this.rankData = res.list.find(item => item.me)
        this.rankData = res
        // console.log('obj', obj)
        // this.rankData = res
      } catch (error) {
        console.log(error)
      }
    },
    // 查询课次并获取试卷/答案
    async feachExamAsync({ planclassesId, id: scheduleExamId }) {
      // const { planclassesId, id: scheduleExamId } = data
      try {
        const res = await feachExam({
          planclassesId,
          scheduleExamId,
        })
        let resultList = []
        this.done = res.done
        const examData = await feachObsO(res.urls[0])
        examData.list.map(item => {
          item.list.map(val => {
            val.checked = false
            val.isCorrect = false
          })
        })
        console.log('examData', examData)
        this.examData = examData
        this.params.examId = res.id
        if (res.done) {
          this.getExamRankAsync(this.params)
          if (res.stuAnswerUrl) {
            const res2 = await feachObsO(res.stuAnswerUrl)
            console.log(res2)
            resultList = JSON.parse(res2.list)
          }
        }
        this.quesList = this.formatList(examData.quesTypeList, examData.list, resultList)
        console.log('quesList', this.quesList)
      } catch (error) {
        console.error(error)
      }
    },
    formatAnswers({ answerOption, id, type }, { option }) {
      const arr1 = option.sort()
      const arr2 = answerOption.split(',').sort()
      const userAnswer = arr1.join(',')
      const answer = arr2.join(',')
      const isRight = answer === userAnswer ? 'Y' : 'N'
      console.log('isRight---', isRight)
      // console.log(`正确答案：${answerOption}，我的答案：${userAnswer}，是否正确：${isRight}`)
      return { answerOption, id, type, userAnswer, isRight }
    },
    formatList(typeList, list, resultList = []) {
      const arr = []
      typeList.forEach((item, index) => {
        arr.push({
          ...item,
          list: [],
          num: 0,
          result: [],
        })
      })
      console.log('arr', arr, list)
      arr.forEach((it) => {
        list.forEach((item) => {
          let data = {}
          console.log('item', item)
          if (it.type === item.type) {
            it.list.push({ ...item, myOption: [] })
            it.num += 1
            if (resultList.length) {
              data = resultList.find((it) => it.id === item.id) || {}
            }
            it.result.push({
              id: item.id,
              answerOption: item.answerOption,
              type: item.type,
              ...data,
            })
          }
          // arr[parseInt(item.type) - 1].list.push({ ...item, myOption: [] })
          // arr[parseInt(item.type) - 1].num += 1
          // if (resultList.length) {
          //   data = resultList.find((it) => it.id === item.id) || {}
          // }
          // arr[parseInt(item.type) - 1].result.push({
          //   id: item.id,
          //   answerOption: item.answerOption,
          //   type: arr[parseInt(item.type) - 1].type,
          //   ...data,
          // })
        })
      })
      console.log('dsalfjlkdsajf', arr)
      return arr
    },
    // 锚点
    onAnchor(ev) {
      const vNode = document.getElementById(ev)
      window.scrollTo({
        top: vNode.offsetTop,
        behavior: 'smooth',
      })
    },
  },
}
</script>
<style lang="less" scoped>
.work {
  display: flex;
  padding-top: 18px;
  width: 1200px;
  margin: 0 auto;
  color: #181d21;

  .content {
    // flex: 1;
    width: 892px;
    margin-right: 16px;
  }

  // .limit {}
  .survey {
    height: 100vh;
    position: fixed;
    left: calc((100vw - 1200px) / 2 + 892px);
    // right: calc((100vh - 892px) / 2);
    top: 98px;
    width: 294px;
    overflow-y: auto;
  }
}
</style>
